import { render, staticRenderFns } from "./AwardsList.vue?vue&type=template&id=1d84ac26&scoped=true"
import script from "./AwardsList.vue?vue&type=script&lang=js"
export * from "./AwardsList.vue?vue&type=script&lang=js"
import style0 from "./AwardsList.vue?vue&type=style&index=0&id=1d84ac26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d84ac26",
  null
  
)

export default component.exports